import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import { SendItemsInput, SendItemsOutput, WebAppRoutes } from "types/web-app";

export const sendItems = async (accessToken: string, input: SendItemsInput) => {
  try {
    const response = await fetchWithAuth(
      "/" + WebAppRoutes.SEND_ITEMS,
      accessToken,
      { method: "POST", body: JSON.stringify(input) },
    );

    return (await response.json()) as ServiceResponse<SendItemsOutput>;
  } catch (error) {
    console.error(error);

    throw error;
  }
};
